<template>
  <div class="data-wrap">
    <div class="data-header">
      <div class="title">
        <h2>渔联网全国实时运行平台</h2>
        <h3>Nxin Real-time operation platform</h3>
      </div>
      <i class="close-icon" @click="close"></i>
    </div>
    <div class="data-top">
      <div class="left">
        <top-left></top-left>
      </div>
      <div class="center">
        <top-center></top-center>
      </div>
      <div class="right">
        <top-right></top-right>
      </div>
    </div>
    <div class="data-center">
      <div class="left">
        <center-left></center-left>
      </div>
      <div class="center">
        <center-center></center-center>
      </div>
      <div class="right">
        <center-right></center-right>
      </div>
    </div>
    <div class="data-bottom">
      <div class="left">
        <bottom-left></bottom-left>
      </div>
      <div class="center">
        <bottom-center></bottom-center>
      </div>
      <div class="right">
        <bottom-right></bottom-right>
      </div>
    </div>
  </div>
</template>

<script>
new function() {
  var _self = this;
  _self.width = 1920; //设置默认最大宽度
  _self.fontSize = 100; //默认字体大小
  _self.widthProportion = function() {
    var p =
      ((document.body && document.body.clientWidth) ||
        document.getElementsByTagName("html")[0].offsetWidth) / _self.width;
    return p > 1 ? 1 : p < 0.4 ? 0.5 : p;
  }; //判断当前屏幕尺寸，设置的最大屏幕宽度之间的比例
  _self.changePage = function() {
    document
      .getElementsByTagName("html")[0]
      .setAttribute(
        "style",
        "font-size:" +
          _self.widthProportion() * _self.fontSize +
          "px !important"
      );
  }; //修改根元素html的font-size的植
  _self.changePage();
  window.addEventListener(
    "resize",
    function() {
      _self.changePage();
    },
    false
  ); //侦听屏幕宽度变化
}();

import TopLeft from "../components/nationalData/topLeft";
import TopCenter from "../components/nationalData/topCenter";
import TopRight from "../components/nationalData/topRight";
import CenterLeft from "../components/nationalData/centerLeft.vue";
import CenterCenter from "../components/nationalData/centerCenter.vue";
import CenterRight from "../components/nationalData/centerRight.vue";
import BottomLeft from "../components/nationalData/bottomLeft.vue";
import BottomCenter from "../components/nationalData/bottomCenter.vue";
import BottomRight from "../components/nationalData/bottomRight.vue";
export default {
  data() {
    return {};
  },
  components: {
    TopLeft,
    TopCenter,
    TopRight,
    CenterLeft,
    CenterCenter,
    CenterRight,
    BottomLeft,
    BottomCenter,
    BottomRight
  },
  methods: {
    // 关闭页面
    close() {
      window.close();
    }
  },
  mounted() {
    document.title = "渔联网全国实时运行平台";
  }
};
</script>

<style lang="stylus" scoped>
  .data-wrap {
    > * {
      box-sizing: border-box;
    }
    height: 100vh;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    background: #0d213c url('../assets/images/bigdata/bg.png') no-repeat top;
    background-size: 100% 100%;
    overflow: hidden;
    padding: 0 1.56vw;
    .data-header {
      text-align: center;
      color: #FFF;
      position: relative;
      height: 11.48vh;
      background: url('../assets/images/bigdata/top_bg.png') no-repeat top;
      background-size: 100% 100%;
      .title {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        h2 {
          font-size: 4.4vh;
          font-family: Microsoft YaHei UI;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
        }
        h3 {
          font-size: 0.12rem;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: rgba(153, 153, 153, 1);
        }
      }
      .close-icon {
        width: 0.24rem;
        height: 0.24rem;
        background: url('../assets/images/bigdata/icon_close.png') no-repeat;
        background-size: 0.24rem 0.24rem;
        position: absolute;
        right: 0rem;
        top: 0.28rem;
      }
    }
    .data-top {
      display: flex;
      .left {
        width: 27vw;
        height: 34.33vh;
      }
      .center {
        width: 46vw;
        height: 34.33vh;
      }
      .right {
        width: 27vw;
        height: 34.33vh;
      }
    }
    .data-center {
      display: flex;
      .left {
        width: 34%;
        height: 30.33vh;
      }
      .center {
        width: 33%;
        height: 30.33vh;
      }
      .right {
        width: 28vw;
        height: 30.33vh;
      }
    }
    .data-bottom {
      display: flex;
      .left {
        width: 34%;
        height: 36.33vh;
      }
      .center {
        width: 38%;
        height: 36.33vh;
      }
      .right {
        width: 28vw;
        height: 36.33vh;
      }
    }
  }
</style>
